const install = (app) => {
  // 创建全局自定义指令 v-outside
  app.directive('outside', {
    // 在指令绑定到元素时添加事件监听器
    mounted(el, binding) {
      // 点击元素外部时触发的处理函数
      const handleClickOutside = (event) => {
        if (!el.contains(event.target)) {
          // 点击元素外部，触发绑定的回调函数
          binding.value(event);
        }
      };
      // 在全局添加点击事件监听器
      window.addEventListener('click', handleClickOutside);

      // 在元素上添加自定义数据，以便在 unmounted 时移除事件监听器
      el._clickOutside = handleClickOutside;
    },

    // 在元素解绑时移除事件监听器
    unmounted(el) {
      window.removeEventListener('click', el._clickOutside);
      delete el._clickOutside;
    },
  });
}

export default { install }